// Generated by scripts/generate_flowsheet_catalog.py. Do not edit.
export const eventCatalog = {
  "VITALS.BP": {
    "subjects": [
      "MOTHER"
    ],
    "schema": {
      "type": "object",
      "properties": {
        "systolic": {
          "type": "number",
          "minimum": 1
        },
        "diastolic": {
          "type": "number",
          "minimum": 1
        },
        "position": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "cuff_size": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "arm": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        }
      },
      "required": [
        "systolic",
        "diastolic"
      ],
      "additionalProperties": false
    }
  },
  "VITALS.PULSE": {
    "subjects": [
      "MOTHER",
      "NEWBORN"
    ],
    "schema": {
      "type": "object",
      "properties": {
        "rate": {
          "type": "number",
          "minimum": 1
        },
        "rhythm": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        }
      },
      "required": [
        "rate"
      ],
      "additionalProperties": false
    }
  },
  "VITALS.TEMP": {
    "subjects": [
      "MOTHER",
      "NEWBORN"
    ],
    "schema": {
      "type": "object",
      "properties": {
        "value_c": {
          "type": "number"
        },
        "method": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        }
      },
      "required": [
        "value_c",
        "method"
      ],
      "additionalProperties": false
    }
  },
  "VITALS.RR": {
    "subjects": [
      "MOTHER",
      "NEWBORN"
    ],
    "schema": {
      "type": "object",
      "properties": {
        "rate": {
          "type": "number",
          "minimum": 0
        },
        "quality": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        }
      },
      "required": [
        "rate"
      ],
      "additionalProperties": false
    }
  },
  "VITALS.SPO2": {
    "subjects": [
      "MOTHER",
      "NEWBORN"
    ],
    "schema": {
      "type": "object",
      "properties": {
        "value_pct": {
          "type": "number",
          "minimum": 0,
          "maximum": 100
        },
        "site": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "on_o2": {
          "type": "boolean"
        }
      },
      "required": [
        "value_pct"
      ],
      "additionalProperties": false
    }
  },
  "VITALS.WEIGHT": {
    "subjects": [
      "MOTHER",
      "NEWBORN"
    ],
    "schema": {
      "type": "object",
      "properties": {
        "grams": {
          "type": "number",
          "minimum": 1
        }
      },
      "required": [
        "grams"
      ],
      "additionalProperties": false
    }
  },
  "VITALS.HEIGHT": {
    "subjects": [
      "MOTHER"
    ],
    "schema": {
      "type": "object",
      "properties": {
        "cm": {
          "type": "number",
          "minimum": 1
        }
      },
      "required": [
        "cm"
      ],
      "additionalProperties": false
    }
  },
  "PRENATAL.FUNDAL_HEIGHT": {
    "subjects": [
      "MOTHER"
    ],
    "schema": {
      "type": "object",
      "properties": {
        "cm": {
          "type": "number",
          "minimum": 0
        },
        "landmark": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "fingers": {
          "type": "number"
        }
      },
      "required": [],
      "additionalProperties": false,
      "anyOf": [
        {
          "required": [
            "cm"
          ]
        },
        {
          "required": [
            "landmark"
          ]
        }
      ]
    }
  },
  "PRENATAL.FHT": {
    "subjects": [
      "FETUS"
    ],
    "schema": {
      "type": "object",
      "properties": {
        "bpm": {
          "type": "number",
          "minimum": 1
        },
        "low_bpm": {
          "type": "number",
          "minimum": 1
        },
        "high_bpm": {
          "type": "number",
          "minimum": 1
        },
        "device": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        }
      },
      "required": [],
      "additionalProperties": false,
      "anyOf": [
        {
          "required": [
            "bpm"
          ]
        },
        {
          "required": [
            "low_bpm",
            "high_bpm"
          ]
        }
      ]
    }
  },
  "PRENATAL.FETAL_PRESENTATION": {
    "subjects": [
      "FETUS"
    ],
    "schema": {
      "type": "object",
      "properties": {
        "presentation": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "position": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "method": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        }
      },
      "required": [
        "presentation"
      ],
      "additionalProperties": false
    }
  },
  "PRENATAL.FETAL_MOVEMENT": {
    "subjects": [
      "FETUS"
    ],
    "schema": {
      "type": "object",
      "properties": {
        "value": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        }
      },
      "required": [
        "value"
      ],
      "additionalProperties": false
    }
  },
  "PRENATAL.EDEMA": {
    "subjects": [
      "MOTHER"
    ],
    "schema": {
      "type": "object",
      "properties": {
        "value": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "location": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        }
      },
      "required": [
        "value"
      ],
      "additionalProperties": false
    }
  },
  "LAB.URINE_DIP": {
    "subjects": [
      "MOTHER"
    ],
    "schema": {
      "type": "object",
      "properties": {
        "protein": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "glucose": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "ketones": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "nitrites": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "leukocytes": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "blood": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "pH": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "SG": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "color": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "clarity": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        }
      },
      "required": [],
      "additionalProperties": false,
      "minProperties": 1
    }
  },
  "EXAM.SECTION": {
    "subjects": [
      "MOTHER",
      "NEWBORN"
    ],
    "schema": {
      "type": "object",
      "properties": {
        "section": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "findings": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "item": {
                "type": "string",
                "minLength": 1,
                "maxLength": 4000
              },
              "normal": {
                "type": "boolean"
              },
              "note": {
                "type": "string",
                "minLength": 1,
                "maxLength": 4000
              }
            },
            "required": [
              "item"
            ],
            "additionalProperties": false
          },
          "maxItems": 100
        }
      },
      "required": [
        "section",
        "findings"
      ],
      "additionalProperties": false
    }
  },
  "LABOR.FHR": {
    "subjects": [
      "FETUS"
    ],
    "schema": {
      "type": "object",
      "properties": {
        "low_bpm": {
          "type": "number",
          "minimum": 1
        },
        "high_bpm": {
          "type": "number",
          "minimum": 1
        },
        "baseline_bpm": {
          "type": "number",
          "minimum": 1
        },
        "listen_duration_s": {
          "type": "number",
          "minimum": 1
        },
        "device": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "relation_to_ctx": {
          "type": "array",
          "items": {
            "type": "string",
            "minLength": 1,
            "maxLength": 4000
          },
          "maxItems": 100
        },
        "accels": {
          "type": "boolean"
        },
        "decels": {
          "type": "boolean"
        },
        "decel_type": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "baseline_reassessed": {
          "type": "boolean"
        }
      },
      "required": [
        "low_bpm",
        "high_bpm",
        "listen_duration_s",
        "device"
      ],
      "additionalProperties": false
    }
  },
  "LABOR.CONTRACTIONS": {
    "subjects": [
      "MOTHER"
    ],
    "schema": {
      "type": "object",
      "properties": {
        "freq_min_low": {
          "type": "number",
          "minimum": 0
        },
        "freq_min_high": {
          "type": "number",
          "minimum": 0
        },
        "duration_s_low": {
          "type": "number",
          "minimum": 0
        },
        "duration_s_high": {
          "type": "number",
          "minimum": 0
        },
        "strength": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "palpated_or_reported": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        }
      },
      "required": [
        "freq_min_low",
        "duration_s_low"
      ],
      "additionalProperties": false
    }
  },
  "LABOR.PROGRESS": {
    "subjects": [
      "MOTHER"
    ],
    "schema": {
      "type": "object",
      "properties": {
        "dilation_cm": {
          "type": "number",
          "minimum": 0,
          "maximum": 10,
          "multipleOf": 0.5
        },
        "effacement_pct": {
          "type": "number",
          "minimum": 0,
          "maximum": 100
        },
        "cervical_length_cm": {
          "type": "number",
          "minimum": 0
        },
        "station": {
          "type": "integer",
          "minimum": -5,
          "maximum": 5
        },
        "cervix_consistency": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "cervix_position": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "notes": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "active_labor": {
          "type": "boolean"
        },
        "exam_by": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        }
      },
      "required": [
        "dilation_cm"
      ],
      "additionalProperties": false
    }
  },
  "LABOR.STATUS": {
    "subjects": [
      "MOTHER"
    ],
    "schema": {
      "type": "object",
      "properties": {
        "value": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        }
      },
      "required": [
        "value"
      ],
      "additionalProperties": false
    }
  },
  "LABOR.COMFORT": {
    "subjects": [
      "MOTHER"
    ],
    "schema": {
      "type": "object",
      "properties": {
        "coping": {
          "type": "boolean"
        },
        "pain_score": {
          "type": "number",
          "minimum": 0,
          "maximum": 10
        },
        "signs_plan": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        }
      },
      "required": [],
      "additionalProperties": false
    }
  },
  "LABOR.POSITION": {
    "subjects": [
      "MOTHER"
    ],
    "schema": {
      "type": "object",
      "properties": {
        "position": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "in_water": {
          "type": "boolean"
        }
      },
      "required": [
        "position"
      ],
      "additionalProperties": false
    }
  },
  "LABOR.FETAL_POSITION": {
    "subjects": [
      "FETUS"
    ],
    "schema": {
      "type": "object",
      "properties": {
        "presentation": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "position": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "attitude": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "asynclitic": {
          "type": "boolean"
        }
      },
      "required": [
        "presentation"
      ],
      "additionalProperties": false
    }
  },
  "LABOR.MEMBRANES": {
    "subjects": [
      "MOTHER"
    ],
    "schema": {
      "type": "object",
      "properties": {
        "status": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "fluid_color": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "pooling": {
          "type": "boolean"
        },
        "nitrazine": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "fern": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "odor": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        }
      },
      "required": [
        "status"
      ],
      "additionalProperties": false
    }
  },
  "IO.INTAKE": {
    "subjects": [
      "MOTHER",
      "NEWBORN"
    ],
    "schema": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "amount_ml": {
          "type": "number",
          "minimum": 0
        },
        "description": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        }
      },
      "required": [
        "type"
      ],
      "additionalProperties": false
    }
  },
  "IO.OUTPUT": {
    "subjects": [
      "MOTHER",
      "NEWBORN"
    ],
    "schema": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "amount_ml": {
          "type": "number",
          "minimum": 0
        },
        "description": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        }
      },
      "required": [
        "type"
      ],
      "additionalProperties": false
    }
  },
  "MED.ADMIN": {
    "subjects": [
      "MOTHER",
      "NEWBORN"
    ],
    "schema": {
      "type": "object",
      "properties": {
        "drug": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "dose": {
          "type": "number",
          "minimum": 0
        },
        "unit": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "route": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "site": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "lot": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "expiration": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "reasons": {
          "type": "array",
          "items": {
            "type": "string",
            "minLength": 1,
            "maxLength": 4000
          },
          "maxItems": 100
        },
        "status": {
          "type": "string",
          "enum": [
            "Administered",
            "Declined",
            "Held",
            "Deferred"
          ]
        }
      },
      "required": [
        "drug",
        "status"
      ],
      "additionalProperties": false
    }
  },
  "THERAPY": {
    "subjects": [
      "MOTHER",
      "NEWBORN"
    ],
    "schema": {
      "type": "object",
      "properties": {
        "therapy": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "reasons": {
          "type": "array",
          "items": {
            "type": "string",
            "minLength": 1,
            "maxLength": 4000
          },
          "maxItems": 100
        }
      },
      "required": [
        "therapy"
      ],
      "additionalProperties": false
    }
  },
  "MILESTONE": {
    "subjects": [
      "MOTHER",
      "FETUS"
    ],
    "schema": {
      "type": "object",
      "properties": {
        "milestone": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "nuchal_cord": {
          "type": "boolean"
        },
        "nuchal_detail": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        }
      },
      "required": [
        "milestone"
      ],
      "additionalProperties": false
    }
  },
  "ROM": {
    "subjects": [
      "MOTHER"
    ],
    "schema": {
      "type": "object",
      "properties": {
        "method": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "confirmed_by": {
          "type": "array",
          "items": {
            "type": "string",
            "minLength": 1,
            "maxLength": 4000
          },
          "maxItems": 100
        },
        "fluid_color": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "amount": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "odor": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        }
      },
      "required": [
        "method",
        "fluid_color"
      ],
      "additionalProperties": false
    }
  },
  "BIRTH": {
    "subjects": [
      "FETUS"
    ],
    "schema": {
      "type": "object",
      "properties": {
        "outcome": {
          "type": "string",
          "enum": [
            "Live birth",
            "Stillbirth"
          ]
        },
        "maternal_position": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "in_water": {
          "type": "boolean"
        },
        "presentation": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "position_of_presenting_part": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "method": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "sex": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "time_estimated": {
          "type": "boolean"
        },
        "shoulder_dystocia": {
          "type": "boolean"
        },
        "maneuvers": {
          "type": "array",
          "items": {
            "type": "string",
            "minLength": 1,
            "maxLength": 4000
          },
          "maxItems": 100
        },
        "head_to_body_interval_s": {
          "type": "number",
          "minimum": 0
        }
      },
      "required": [
        "outcome",
        "method"
      ],
      "additionalProperties": false
    }
  },
  "APGAR": {
    "subjects": [
      "NEWBORN"
    ],
    "schema": {
      "type": "object",
      "properties": {
        "minute": {
          "type": "integer",
          "minimum": 0
        },
        "heart_rate": {
          "type": "integer",
          "minimum": 0,
          "maximum": 2
        },
        "resp_effort": {
          "type": "integer",
          "minimum": 0,
          "maximum": 2
        },
        "reflex": {
          "type": "integer",
          "minimum": 0,
          "maximum": 2
        },
        "tone": {
          "type": "integer",
          "minimum": 0,
          "maximum": 2
        },
        "color": {
          "type": "integer",
          "minimum": 0,
          "maximum": 2
        }
      },
      "required": [
        "minute",
        "heart_rate",
        "resp_effort",
        "reflex",
        "tone",
        "color"
      ],
      "additionalProperties": false
    }
  },
  "CORD": {
    "subjects": [
      "NEWBORN"
    ],
    "schema": {
      "type": "object",
      "properties": {
        "clamped_at": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "cut_at": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "cut_by": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "vessels": {
          "type": "string",
          "enum": [
            "2",
            "3"
          ]
        },
        "cord_blood_collected": {
          "type": "boolean"
        }
      },
      "required": [],
      "additionalProperties": false
    }
  },
  "PLACENTA": {
    "subjects": [
      "MOTHER"
    ],
    "schema": {
      "type": "object",
      "properties": {
        "delivery_method": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "presentation": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "intact": {
          "type": "boolean"
        },
        "membranes_complete": {
          "type": "boolean"
        },
        "appearance": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "note": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "vessels": {
          "type": "string",
          "enum": [
            "2",
            "3"
          ]
        },
        "weight_g": {
          "type": "number",
          "minimum": 0
        },
        "disposition": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        }
      },
      "required": [
        "delivery_method"
      ],
      "additionalProperties": false
    }
  },
  "PP.FUNDUS": {
    "subjects": [
      "MOTHER"
    ],
    "schema": {
      "type": "object",
      "properties": {
        "relation_to_umbilicus_fb": {
          "type": "number",
          "minimum": -4,
          "maximum": 2
        },
        "deviation": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "tone": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        }
      },
      "required": [
        "tone"
      ],
      "additionalProperties": false
    }
  },
  "PP.BLOOD_LOSS": {
    "subjects": [
      "MOTHER"
    ],
    "schema": {
      "type": "object",
      "properties": {
        "amount_ml": {
          "type": "number",
          "minimum": 0
        },
        "method": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "descriptor": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        }
      },
      "required": [],
      "additionalProperties": false,
      "anyOf": [
        {
          "required": [
            "amount_ml",
            "method"
          ]
        },
        {
          "required": [
            "descriptor"
          ]
        }
      ]
    }
  },
  "PP.PERINEUM": {
    "subjects": [
      "MOTHER"
    ],
    "schema": {
      "type": "object",
      "properties": {
        "status": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "other_lacerations": {
          "type": "array",
          "items": {
            "type": "string",
            "minLength": 1,
            "maxLength": 4000
          },
          "maxItems": 100
        },
        "repair": {
          "type": "boolean"
        },
        "repair_detail": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "suture": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "anesthetic": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "edema": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "hematoma": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        }
      },
      "required": [
        "status"
      ],
      "additionalProperties": false
    }
  },
  "NB.COLOR": {
    "subjects": [
      "NEWBORN"
    ],
    "schema": {
      "type": "object",
      "properties": {
        "value": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        }
      },
      "required": [
        "value"
      ],
      "additionalProperties": false
    }
  },
  "NB.FEEDING": {
    "subjects": [
      "NEWBORN"
    ],
    "schema": {
      "type": "object",
      "properties": {
        "method": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "first_latch": {
          "type": "boolean"
        },
        "side": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "duration_min": {
          "type": "number",
          "minimum": 0
        },
        "latch_score": {
          "type": "number",
          "minimum": 0
        }
      },
      "required": [
        "method"
      ],
      "additionalProperties": false
    }
  },
  "NB.LOCATION": {
    "subjects": [
      "NEWBORN"
    ],
    "schema": {
      "type": "object",
      "properties": {
        "value": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "in_water": {
          "type": "boolean"
        }
      },
      "required": [
        "value"
      ],
      "additionalProperties": false
    }
  },
  "NB.RESUSCITATION": {
    "subjects": [
      "NEWBORN"
    ],
    "schema": {
      "type": "object",
      "properties": {
        "interventions": {
          "type": "array",
          "items": {
            "type": "string",
            "minLength": 1,
            "maxLength": 4000
          },
          "maxItems": 100
        },
        "started_at": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "stopped_at": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "notes": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        }
      },
      "required": [
        "interventions"
      ],
      "additionalProperties": false
    }
  },
  "NB.MEASUREMENTS": {
    "subjects": [
      "NEWBORN"
    ],
    "schema": {
      "type": "object",
      "properties": {
        "weight_g": {
          "type": "number",
          "minimum": 1
        },
        "length_cm": {
          "type": "number",
          "minimum": 1
        },
        "head_circ_cm": {
          "type": "number",
          "minimum": 1
        },
        "chest_circ_cm": {
          "type": "number",
          "minimum": 1
        }
      },
      "required": [
        "weight_g"
      ],
      "additionalProperties": false
    }
  },
  "NB.EXAM": {
    "subjects": [
      "NEWBORN"
    ],
    "schema": {
      "type": "object",
      "properties": {
        "findings": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "section": {
                "type": "string",
                "minLength": 1,
                "maxLength": 4000
              },
              "item": {
                "type": "string",
                "minLength": 1,
                "maxLength": 4000
              },
              "normal": {
                "type": "boolean"
              },
              "note": {
                "type": "string",
                "minLength": 1,
                "maxLength": 4000
              }
            },
            "required": [
              "section",
              "item"
            ],
            "additionalProperties": false
          },
          "maxItems": 100
        }
      },
      "required": [
        "findings"
      ],
      "additionalProperties": false
    }
  },
  "NB.SCREEN": {
    "subjects": [
      "NEWBORN"
    ],
    "schema": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "result": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "values": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "name": {
                "type": "string",
                "minLength": 1,
                "maxLength": 4000
              },
              "value": {
                "type": "number"
              },
              "unit": {
                "type": "string",
                "minLength": 1,
                "maxLength": 4000
              }
            },
            "required": [
              "name",
              "value"
            ],
            "additionalProperties": false
          },
          "maxItems": 100
        }
      },
      "required": [
        "type",
        "result"
      ],
      "additionalProperties": false
    }
  },
  "TRANSPORT": {
    "subjects": [
      "MOTHER",
      "NEWBORN"
    ],
    "schema": {
      "type": "object",
      "properties": {
        "transport_type": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "decision_at": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "deciding_provider_id": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "urgency": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "reasons": {
          "type": "array",
          "items": {
            "type": "string",
            "minLength": 1,
            "maxLength": 4000
          },
          "maxItems": 100
        },
        "reason_other": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "mode": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "transporting_from": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "receiving_facility": {
          "type": "object",
          "properties": {
            "name": {
              "type": "string",
              "minLength": 1,
              "maxLength": 4000
            },
            "phone": {
              "type": "string",
              "minLength": 1,
              "maxLength": 4000
            },
            "contact_name": {
              "type": "string",
              "minLength": 1,
              "maxLength": 4000
            }
          },
          "required": [
            "name"
          ],
          "additionalProperties": false
        },
        "facility_notified_at": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "condition_at_transport": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "arrived_facility_at": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "disposition_of_mother": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "accompanying": {
          "type": "array",
          "items": {
            "type": "string",
            "minLength": 1,
            "maxLength": 4000
          },
          "maxItems": 100
        },
        "outcome_followup": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        }
      },
      "required": [
        "transport_type",
        "decision_at",
        "reasons"
      ],
      "additionalProperties": false
    }
  },
  "NOTE.ADMISSION": {
    "subjects": [
      "MOTHER",
      "FETUS",
      "NEWBORN"
    ],
    "schema": {
      "type": "object",
      "properties": {
        "text": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        }
      },
      "required": [
        "text"
      ],
      "additionalProperties": false
    }
  },
  "NOTE.DISCHARGE": {
    "subjects": [
      "MOTHER",
      "FETUS",
      "NEWBORN"
    ],
    "schema": {
      "type": "object",
      "properties": {
        "text": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        }
      },
      "required": [
        "text"
      ],
      "additionalProperties": false
    }
  },
  "NOTE.PROGRESS": {
    "subjects": [
      "MOTHER",
      "FETUS",
      "NEWBORN"
    ],
    "schema": {
      "type": "object",
      "properties": {
        "text": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        }
      },
      "required": [
        "text"
      ],
      "additionalProperties": false
    }
  },
  "ATTENDANT.ARRIVAL": {
    "subjects": [
      "MOTHER"
    ],
    "schema": {
      "type": "object",
      "properties": {
        "person": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "role": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        }
      },
      "required": [
        "person",
        "role"
      ],
      "additionalProperties": false
    }
  },
  "ATTENDANT.DEPARTURE": {
    "subjects": [
      "MOTHER"
    ],
    "schema": {
      "type": "object",
      "properties": {
        "person": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "role": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        }
      },
      "required": [
        "person",
        "role"
      ],
      "additionalProperties": false
    }
  },
  "SCREEN.EPDS": {
    "subjects": [
      "MOTHER"
    ],
    "schema": {
      "type": "object",
      "properties": {
        "items": {
          "type": "array",
          "items": {
            "type": "integer",
            "minimum": 0,
            "maximum": 3
          },
          "maxItems": 10,
          "minItems": 10
        }
      },
      "required": [
        "items"
      ],
      "additionalProperties": false
    }
  },
  "CONSENT.DECISION": {
    "subjects": [
      "MOTHER",
      "FETUS",
      "NEWBORN"
    ],
    "schema": {
      "type": "object",
      "properties": {
        "test": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "decision": {
          "type": "string",
          "enum": [
            "CONSENTED",
            "DECLINED",
            "DEFERRED"
          ]
        },
        "form_document_id": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "witnessed_by": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        }
      },
      "required": [
        "test",
        "decision"
      ],
      "additionalProperties": false
    }
  },
  "CHECKLIST.ITEM": {
    "subjects": [
      "MOTHER",
      "FETUS",
      "NEWBORN"
    ],
    "schema": {
      "type": "object",
      "properties": {
        "item_id": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "template_version": {
          "type": "integer",
          "minimum": 1
        },
        "status": {
          "type": "string",
          "enum": [
            "COMPLETE",
            "DEFERRED",
            "NOT_APPLICABLE"
          ]
        },
        "note": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        }
      },
      "required": [
        "item_id",
        "template_version",
        "status"
      ],
      "additionalProperties": false
    }
  },
  "PRENATAL.CONTEXT": {
    "subjects": [
      "MOTHER"
    ],
    "schema": {
      "type": "object",
      "properties": {
        "preferred_name": {
          "type": "string",
          "minLength": 1,
          "maxLength": 500
        },
        "support_person": {
          "type": "string",
          "minLength": 1,
          "maxLength": 500
        },
        "planned_birth_site": {
          "type": "string",
          "minLength": 1,
          "maxLength": 500
        },
        "backup_hospital": {
          "type": "string",
          "minLength": 1,
          "maxLength": 500
        },
        "backup_phone": {
          "type": "string",
          "minLength": 1,
          "maxLength": 500
        },
        "pediatric_provider": {
          "type": "string",
          "minLength": 1,
          "maxLength": 500
        },
        "assigned_midwife": {
          "type": "string",
          "minLength": 1,
          "maxLength": 500
        },
        "current_medications": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "risk_flags": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "lmp_certain": {
          "type": "boolean"
        },
        "next_visit_date": {
          "type": "string",
          "format": "date"
        },
        "rh_status": {
          "type": "string",
          "enum": [
            "positive",
            "negative",
            "unknown"
          ]
        },
        "gbs_status": {
          "type": "string",
          "enum": [
            "positive",
            "negative",
            "unknown",
            "declined"
          ]
        },
        "rhig_documented": {
          "type": "boolean"
        },
        "clinical_source": {
          "type": "string",
          "minLength": 1,
          "maxLength": 2000
        }
      },
      "additionalProperties": false,
      "minProperties": 1
    }
  },
  "PRENATAL.CARE_STATUS": {
    "subjects": [
      "MOTHER"
    ],
    "schema": {
      "type": "object",
      "properties": {
        "status": {
          "type": "string",
          "enum": [
            "PRENATAL",
            "IN_LABOR",
            "POSTPARTUM",
            "TRANSFERRED",
            "CLOSED",
            "PREGNANCY_LOSS"
          ]
        },
        "effective_date": {
          "type": "string",
          "format": "date"
        },
        "reason": {
          "type": "string",
          "minLength": 1,
          "maxLength": 2000
        }
      },
      "required": [
        "status",
        "effective_date",
        "reason"
      ],
      "additionalProperties": false
    }
  },
  "PRENATAL.DATING": {
    "subjects": [
      "MOTHER"
    ],
    "schema": {
      "type": "object",
      "properties": {
        "previous_edd": {
          "type": "string",
          "format": "date"
        },
        "edd": {
          "type": "string",
          "format": "date"
        },
        "method": {
          "type": "string",
          "enum": [
            "LMP",
            "ART",
            "ULTRASOUND",
            "CLINICAL"
          ]
        },
        "scan_date": {
          "type": "string",
          "format": "date"
        },
        "ga_at_scan_days": {
          "type": "integer",
          "minimum": 0,
          "maximum": 350
        },
        "configuration_version": {
          "type": "integer",
          "minimum": 1
        },
        "difference_days": {
          "type": "integer",
          "minimum": 0
        },
        "threshold_days": {
          "type": "integer",
          "minimum": 0
        },
        "reason": {
          "type": "string",
          "minLength": 1,
          "maxLength": 2000
        }
      },
      "required": [
        "edd",
        "method",
        "reason"
      ],
      "additionalProperties": false
    }
  },
  "PRENATAL.VISIT_DETAILS": {
    "subjects": [
      "MOTHER"
    ],
    "schema": {
      "type": "object",
      "properties": {
        "labs_drawn": {
          "type": "boolean"
        },
        "rhig_given": {
          "type": "boolean"
        },
        "rhig_date": {
          "type": "string",
          "format": "date"
        },
        "internal_exam": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "education": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "orders": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "urine_other": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        }
      },
      "minProperties": 1,
      "additionalProperties": false,
      "allOf": [
        {
          "if": {
            "properties": {
              "rhig_given": {
                "const": true
              }
            },
            "required": [
              "rhig_given"
            ]
          },
          "then": {
            "required": [
              "rhig_date"
            ]
          }
        }
      ]
    }
  },
  "NB.BLOOD_TYPE": {
    "subjects": [
      "NEWBORN"
    ],
    "schema": {
      "type": "object",
      "properties": {
        "abo": {
          "type": "string",
          "enum": [
            "A",
            "B",
            "AB",
            "O",
            "Unknown"
          ]
        },
        "rh": {
          "type": "string",
          "enum": [
            "Positive",
            "Negative",
            "Unknown"
          ]
        },
        "source": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        }
      },
      "required": [
        "rh",
        "source"
      ],
      "additionalProperties": false
    }
  },
  "POSTPARTUM.OUTCOME_REVIEW": {
    "subjects": [
      "MOTHER"
    ],
    "schema": {
      "type": "object",
      "properties": {
        "prior_history": {
          "type": "object",
          "properties": {
            "gravida": {
              "type": "integer",
              "minimum": 0,
              "maximum": 50
            },
            "term": {
              "type": "integer",
              "minimum": 0,
              "maximum": 50
            },
            "preterm": {
              "type": "integer",
              "minimum": 0,
              "maximum": 50
            },
            "abortions": {
              "type": "integer",
              "minimum": 0,
              "maximum": 50
            },
            "living": {
              "type": "integer",
              "minimum": 0,
              "maximum": 50
            }
          },
          "required": [
            "gravida",
            "term",
            "preterm",
            "abortions",
            "living"
          ],
          "additionalProperties": false
        },
        "classification": {
          "type": "string",
          "enum": [
            "TERM",
            "PRETERM",
            "LOSS"
          ]
        },
        "living_newborns": {
          "type": "integer",
          "minimum": 0,
          "maximum": 12
        },
        "reason": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "prior_history_excludes_current_pregnancy": {
          "const": true,
          "type": "boolean"
        },
        "reviewed_birth_head_ids": {
          "type": "array",
          "items": {
            "type": "string",
            "format": "uuid"
          },
          "minItems": 1,
          "maxItems": 12,
          "uniqueItems": true
        }
      },
      "required": [
        "prior_history",
        "classification",
        "living_newborns",
        "reason",
        "prior_history_excludes_current_pregnancy",
        "reviewed_birth_head_ids"
      ],
      "additionalProperties": false
    }
  },
  "CARE.TASK": {
    "subjects": [
      "MOTHER",
      "NEWBORN"
    ],
    "schema": {
      "type": "object",
      "properties": {
        "task_id": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "status": {
          "type": "string",
          "enum": [
            "COMPLETE",
            "DEFERRED",
            "NOT_APPLICABLE"
          ]
        },
        "note": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        }
      },
      "required": [
        "task_id",
        "status",
        "note"
      ],
      "additionalProperties": false
    }
  },
  "PP.STATUS": {
    "subjects": [
      "MOTHER"
    ],
    "schema": {
      "type": "object",
      "properties": {
        "status": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "note": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        }
      },
      "required": [
        "status"
      ],
      "additionalProperties": false
    }
  },
  "BIRTH.DISCHARGE": {
    "subjects": [
      "MOTHER"
    ],
    "schema": {
      "type": "object",
      "properties": {
        "checklist_version": {
          "type": "integer",
          "minimum": 1
        },
        "reviewed_event_ids": {
          "type": "array",
          "items": {
            "type": "string",
            "format": "uuid"
          },
          "maxItems": 200,
          "uniqueItems": true
        },
        "override_reason": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "text": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        }
      },
      "required": [
        "checklist_version",
        "reviewed_event_ids",
        "text"
      ],
      "additionalProperties": false
    }
  },
  "NB.BALLARD": {
    "subjects": [
      "NEWBORN"
    ],
    "schema": {
      "type": "object",
      "properties": {
        "posture": {
          "type": "integer",
          "minimum": 0,
          "maximum": 4
        },
        "square_window": {
          "type": "integer",
          "minimum": -1,
          "maximum": 4
        },
        "arm_recoil": {
          "type": "integer",
          "minimum": 0,
          "maximum": 4
        },
        "popliteal_angle": {
          "type": "integer",
          "minimum": -1,
          "maximum": 5
        },
        "scarf_sign": {
          "type": "integer",
          "minimum": -1,
          "maximum": 4
        },
        "heel_to_ear": {
          "type": "integer",
          "minimum": -1,
          "maximum": 4
        },
        "skin": {
          "type": "integer",
          "minimum": -1,
          "maximum": 5
        },
        "lanugo": {
          "type": "integer",
          "minimum": -1,
          "maximum": 4
        },
        "plantar_surface": {
          "type": "integer",
          "minimum": -2,
          "maximum": 4
        },
        "breast": {
          "type": "integer",
          "minimum": -1,
          "maximum": 4
        },
        "eye_ear": {
          "type": "integer",
          "minimum": -2,
          "maximum": 4
        },
        "genitals": {
          "type": "integer",
          "minimum": -1,
          "maximum": 4
        }
      },
      "required": [
        "posture",
        "square_window",
        "arm_recoil",
        "popliteal_angle",
        "scarf_sign",
        "heel_to_ear",
        "skin",
        "lanugo",
        "plantar_surface",
        "breast",
        "eye_ear",
        "genitals"
      ],
      "additionalProperties": false
    }
  },
  "PP.EPDS": {
    "subjects": [
      "MOTHER"
    ],
    "schema": {
      "type": "object",
      "properties": {
        "item_scores": {
          "type": "array",
          "items": {
            "type": "integer",
            "minimum": 0,
            "maximum": 3
          },
          "minItems": 10,
          "maxItems": 10
        },
        "instrument_version": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "administered_date": {
          "type": "string",
          "format": "date"
        },
        "notes": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        }
      },
      "required": [
        "item_scores",
        "instrument_version"
      ],
      "additionalProperties": false
    }
  },
  "PP.COURSE_ASSESSMENT": {
    "subjects": [
      "MOTHER"
    ],
    "schema": {
      "type": "object",
      "properties": {
        "lochia_color": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "lochia_amount": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "lochia_odor": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "perineum_healing": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "incision_healing": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "breasts": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "nipples": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "bladder": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "bowel": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "mood": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "contraception_plan": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "notes": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "pain_score": {
          "type": "number",
          "minimum": 0,
          "maximum": 10
        }
      },
      "required": [],
      "additionalProperties": false
    }
  },
  "NB.COURSE_ASSESSMENT": {
    "subjects": [
      "NEWBORN"
    ],
    "schema": {
      "type": "object",
      "properties": {
        "latch": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "jaundice_visual_zone": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "cord": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "metabolic_screen_status": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "cchd_status": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "hearing_status": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "exam_findings": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "notes": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "feeding_frequency_per24h": {
          "type": "integer",
          "minimum": 0,
          "maximum": 100
        },
        "voids_per24h": {
          "type": "integer",
          "minimum": 0,
          "maximum": 100
        },
        "stools_per24h": {
          "type": "integer",
          "minimum": 0,
          "maximum": 100
        },
        "tcb_value": {
          "type": "number",
          "minimum": 0
        },
        "tcb_unit": {
          "type": "string",
          "enum": [
            "mg/dL",
            "umol/L"
          ]
        }
      },
      "required": [],
      "additionalProperties": false
    }
  },
  "US.MEASUREMENT": {
    "subjects": [
      "FETUS"
    ],
    "schema": {
      "type": "object",
      "properties": {
        "metric": {
          "type": "string",
          "enum": [
            "EFW",
            "BPD",
            "HC",
            "AC",
            "FL",
            "AFI",
            "FHR"
          ]
        },
        "value": {
          "type": "number",
          "exclusiveMinimum": 0
        },
        "unit": {
          "type": "string",
          "enum": [
            "g",
            "grams",
            "mm",
            "cm",
            "bpm"
          ]
        }
      },
      "required": [
        "metric",
        "value",
        "unit"
      ],
      "additionalProperties": false
    }
  }
} as const;
export interface EventPayloads {
  "VITALS.BP": { "systolic": number; "diastolic": number; "position"?: string; "cuff_size"?: string; "arm"?: string };
  "VITALS.PULSE": { "rate": number; "rhythm"?: string };
  "VITALS.TEMP": { "value_c": number; "method": string };
  "VITALS.RR": { "rate": number; "quality"?: string };
  "VITALS.SPO2": { "value_pct": number; "site"?: string; "on_o2"?: boolean };
  "VITALS.WEIGHT": { "grams": number };
  "VITALS.HEIGHT": { "cm": number };
  "PRENATAL.FUNDAL_HEIGHT": { "cm"?: number; "landmark"?: string; "fingers"?: number };
  "PRENATAL.FHT": { "bpm"?: number; "low_bpm"?: number; "high_bpm"?: number; "device"?: string };
  "PRENATAL.FETAL_PRESENTATION": { "presentation": string; "position"?: string; "method"?: string };
  "PRENATAL.FETAL_MOVEMENT": { "value": string };
  "PRENATAL.EDEMA": { "value": string; "location"?: string };
  "LAB.URINE_DIP": { "protein"?: string; "glucose"?: string; "ketones"?: string; "nitrites"?: string; "leukocytes"?: string; "blood"?: string; "pH"?: string; "SG"?: string; "color"?: string; "clarity"?: string };
  "EXAM.SECTION": { "section": string; "findings": ({ "item": string; "normal"?: boolean; "note"?: string })[] };
  "LABOR.FHR": { "low_bpm": number; "high_bpm": number; "baseline_bpm"?: number; "listen_duration_s": number; "device": string; "relation_to_ctx"?: (string)[]; "accels"?: boolean; "decels"?: boolean; "decel_type"?: string; "baseline_reassessed"?: boolean };
  "LABOR.CONTRACTIONS": { "freq_min_low": number; "freq_min_high"?: number; "duration_s_low": number; "duration_s_high"?: number; "strength"?: string; "palpated_or_reported"?: string };
  "LABOR.PROGRESS": { "dilation_cm": number; "effacement_pct"?: number; "cervical_length_cm"?: number; "station"?: number; "cervix_consistency"?: string; "cervix_position"?: string; "notes"?: string; "active_labor"?: boolean; "exam_by"?: string };
  "LABOR.STATUS": { "value": string };
  "LABOR.COMFORT": { "coping"?: boolean; "pain_score"?: number; "signs_plan"?: string };
  "LABOR.POSITION": { "position": string; "in_water"?: boolean };
  "LABOR.FETAL_POSITION": { "presentation": string; "position"?: string; "attitude"?: string; "asynclitic"?: boolean };
  "LABOR.MEMBRANES": { "status": string; "fluid_color"?: string; "pooling"?: boolean; "nitrazine"?: string; "fern"?: string; "odor"?: string };
  "IO.INTAKE": { "type": string; "amount_ml"?: number; "description"?: string };
  "IO.OUTPUT": { "type": string; "amount_ml"?: number; "description"?: string };
  "MED.ADMIN": { "drug": string; "dose"?: number; "unit"?: string; "route"?: string; "site"?: string; "lot"?: string; "expiration"?: string; "reasons"?: (string)[]; "status": "Administered" | "Declined" | "Held" | "Deferred" };
  "THERAPY": { "therapy": string; "reasons"?: (string)[] };
  "MILESTONE": { "milestone": string; "nuchal_cord"?: boolean; "nuchal_detail"?: string };
  "ROM": { "method": string; "confirmed_by"?: (string)[]; "fluid_color": string; "amount"?: string; "odor"?: string };
  "BIRTH": { "outcome": "Live birth" | "Stillbirth"; "maternal_position"?: string; "in_water"?: boolean; "presentation"?: string; "position_of_presenting_part"?: string; "method": string; "sex"?: string; "time_estimated"?: boolean; "shoulder_dystocia"?: boolean; "maneuvers"?: (string)[]; "head_to_body_interval_s"?: number };
  "APGAR": { "minute": number; "heart_rate": number; "resp_effort": number; "reflex": number; "tone": number; "color": number };
  "CORD": { "clamped_at"?: string; "cut_at"?: string; "cut_by"?: string; "vessels"?: "2" | "3"; "cord_blood_collected"?: boolean };
  "PLACENTA": { "delivery_method": string; "presentation"?: string; "intact"?: boolean; "membranes_complete"?: boolean; "appearance"?: string; "note"?: string; "vessels"?: "2" | "3"; "weight_g"?: number; "disposition"?: string };
  "PP.FUNDUS": { "relation_to_umbilicus_fb"?: number; "deviation"?: string; "tone": string };
  "PP.BLOOD_LOSS": { "amount_ml"?: number; "method"?: string; "descriptor"?: string };
  "PP.PERINEUM": { "status": string; "other_lacerations"?: (string)[]; "repair"?: boolean; "repair_detail"?: string; "suture"?: string; "anesthetic"?: string; "edema"?: string; "hematoma"?: string };
  "NB.COLOR": { "value": string };
  "NB.FEEDING": { "method": string; "first_latch"?: boolean; "side"?: string; "duration_min"?: number; "latch_score"?: number };
  "NB.LOCATION": { "value": string; "in_water"?: boolean };
  "NB.RESUSCITATION": { "interventions": (string)[]; "started_at"?: string; "stopped_at"?: string; "notes"?: string };
  "NB.MEASUREMENTS": { "weight_g": number; "length_cm"?: number; "head_circ_cm"?: number; "chest_circ_cm"?: number };
  "NB.EXAM": { "findings": ({ "section": string; "item": string; "normal"?: boolean; "note"?: string })[] };
  "NB.SCREEN": { "type": string; "result": string; "values"?: ({ "name": string; "value": number; "unit"?: string })[] };
  "TRANSPORT": { "transport_type": string; "decision_at": string; "deciding_provider_id"?: string; "urgency"?: string; "reasons": (string)[]; "reason_other"?: string; "mode"?: string; "transporting_from"?: string; "receiving_facility"?: { "name": string; "phone"?: string; "contact_name"?: string }; "facility_notified_at"?: string; "condition_at_transport"?: string; "arrived_facility_at"?: string; "disposition_of_mother"?: string; "accompanying"?: (string)[]; "outcome_followup"?: string };
  "NOTE.ADMISSION": { "text": string };
  "NOTE.DISCHARGE": { "text": string };
  "NOTE.PROGRESS": { "text": string };
  "ATTENDANT.ARRIVAL": { "person": string; "role": string };
  "ATTENDANT.DEPARTURE": { "person": string; "role": string };
  "SCREEN.EPDS": { "items": (number)[] };
  "CONSENT.DECISION": { "test": string; "decision": "CONSENTED" | "DECLINED" | "DEFERRED"; "form_document_id"?: string; "witnessed_by"?: string };
  "CHECKLIST.ITEM": { "item_id": string; "template_version": number; "status": "COMPLETE" | "DEFERRED" | "NOT_APPLICABLE"; "note"?: string };
  "PRENATAL.CONTEXT": { "preferred_name"?: string; "support_person"?: string; "planned_birth_site"?: string; "backup_hospital"?: string; "backup_phone"?: string; "pediatric_provider"?: string; "assigned_midwife"?: string; "current_medications"?: string; "risk_flags"?: string; "lmp_certain"?: boolean; "next_visit_date"?: string; "rh_status"?: "positive" | "negative" | "unknown"; "gbs_status"?: "positive" | "negative" | "unknown" | "declined"; "rhig_documented"?: boolean; "clinical_source"?: string };
  "PRENATAL.CARE_STATUS": { "status": "PRENATAL" | "IN_LABOR" | "POSTPARTUM" | "TRANSFERRED" | "CLOSED" | "PREGNANCY_LOSS"; "effective_date": string; "reason": string };
  "PRENATAL.DATING": { "previous_edd"?: string; "edd": string; "method": "LMP" | "ART" | "ULTRASOUND" | "CLINICAL"; "scan_date"?: string; "ga_at_scan_days"?: number; "configuration_version"?: number; "difference_days"?: number; "threshold_days"?: number; "reason": string };
  "PRENATAL.VISIT_DETAILS": { "labs_drawn"?: boolean; "rhig_given"?: boolean; "rhig_date"?: string; "internal_exam"?: string; "education"?: string; "orders"?: string; "urine_other"?: string };
  "NB.BLOOD_TYPE": { "abo"?: "A" | "B" | "AB" | "O" | "Unknown"; "rh": "Positive" | "Negative" | "Unknown"; "source": string };
  "POSTPARTUM.OUTCOME_REVIEW": { "prior_history": { "gravida": number; "term": number; "preterm": number; "abortions": number; "living": number }; "classification": "TERM" | "PRETERM" | "LOSS"; "living_newborns": number; "reason": string; "prior_history_excludes_current_pregnancy": boolean; "reviewed_birth_head_ids": (string)[] };
  "CARE.TASK": { "task_id": string; "status": "COMPLETE" | "DEFERRED" | "NOT_APPLICABLE"; "note": string };
  "PP.STATUS": { "status": string; "note"?: string };
  "BIRTH.DISCHARGE": { "checklist_version": number; "reviewed_event_ids": (string)[]; "override_reason"?: string; "text": string };
  "NB.BALLARD": { "posture": number; "square_window": number; "arm_recoil": number; "popliteal_angle": number; "scarf_sign": number; "heel_to_ear": number; "skin": number; "lanugo": number; "plantar_surface": number; "breast": number; "eye_ear": number; "genitals": number };
  "PP.EPDS": { "item_scores": (number)[]; "instrument_version": string; "administered_date"?: string; "notes"?: string };
  "PP.COURSE_ASSESSMENT": { "lochia_color"?: string; "lochia_amount"?: string; "lochia_odor"?: string; "perineum_healing"?: string; "incision_healing"?: string; "breasts"?: string; "nipples"?: string; "bladder"?: string; "bowel"?: string; "mood"?: string; "contraception_plan"?: string; "notes"?: string; "pain_score"?: number };
  "NB.COURSE_ASSESSMENT": { "latch"?: string; "jaundice_visual_zone"?: string; "cord"?: string; "metabolic_screen_status"?: string; "cchd_status"?: string; "hearing_status"?: string; "exam_findings"?: string; "notes"?: string; "feeding_frequency_per24h"?: number; "voids_per24h"?: number; "stools_per24h"?: number; "tcb_value"?: number; "tcb_unit"?: "mg/dL" | "umol/L" };
  "US.MEASUREMENT": { "metric": "EFW" | "BPD" | "HC" | "AC" | "FL" | "AFI" | "FHR"; "value": number; "unit": "g" | "grams" | "mm" | "cm" | "bpm" };
}
export type EventType = keyof EventPayloads;
export const eventCatalogV2 = {
  "VITALS.BP": {
    "subjects": [
      "MOTHER"
    ],
    "schema": {
      "type": "object",
      "properties": {
        "systolic": {
          "type": "number",
          "minimum": 1
        },
        "diastolic": {
          "type": "number",
          "minimum": 1
        },
        "position": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "cuff_size": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "arm": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "performed_by": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        }
      },
      "required": [
        "systolic",
        "diastolic"
      ],
      "additionalProperties": false
    }
  },
  "VITALS.PULSE": {
    "subjects": [
      "MOTHER",
      "NEWBORN"
    ],
    "schema": {
      "type": "object",
      "properties": {
        "rate": {
          "type": "number",
          "minimum": 1
        },
        "rhythm": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "performed_by": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        }
      },
      "required": [
        "rate"
      ],
      "additionalProperties": false
    }
  },
  "VITALS.TEMP": {
    "subjects": [
      "MOTHER",
      "NEWBORN"
    ],
    "schema": {
      "type": "object",
      "properties": {
        "value_c": {
          "type": "number"
        },
        "method": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "performed_by": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        }
      },
      "required": [
        "value_c",
        "method"
      ],
      "additionalProperties": false
    }
  },
  "VITALS.RR": {
    "subjects": [
      "MOTHER",
      "NEWBORN"
    ],
    "schema": {
      "type": "object",
      "properties": {
        "rate": {
          "type": "number",
          "minimum": 0
        },
        "quality": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "performed_by": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "respiratory_distress": {
          "type": "boolean"
        }
      },
      "required": [
        "rate"
      ],
      "additionalProperties": false
    }
  },
  "VITALS.SPO2": {
    "subjects": [
      "MOTHER",
      "NEWBORN"
    ],
    "schema": {
      "type": "object",
      "properties": {
        "value_pct": {
          "type": "number",
          "minimum": 0,
          "maximum": 100
        },
        "site": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "on_o2": {
          "type": "boolean"
        },
        "performed_by": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        }
      },
      "required": [
        "value_pct"
      ],
      "additionalProperties": false
    }
  },
  "VITALS.WEIGHT": {
    "subjects": [
      "MOTHER",
      "NEWBORN"
    ],
    "schema": {
      "type": "object",
      "properties": {
        "grams": {
          "type": "number",
          "minimum": 1
        },
        "performed_by": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        }
      },
      "required": [
        "grams"
      ],
      "additionalProperties": false
    }
  },
  "VITALS.HEIGHT": {
    "subjects": [
      "MOTHER"
    ],
    "schema": {
      "type": "object",
      "properties": {
        "cm": {
          "type": "number",
          "minimum": 1
        },
        "performed_by": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        }
      },
      "required": [
        "cm"
      ],
      "additionalProperties": false
    }
  },
  "LABOR.FHR": {
    "subjects": [
      "FETUS"
    ],
    "schema": {
      "type": "object",
      "properties": {
        "low_bpm": {
          "type": "number",
          "minimum": 1
        },
        "high_bpm": {
          "type": "number",
          "minimum": 1
        },
        "baseline_bpm": {
          "type": "number",
          "minimum": 1
        },
        "listen_duration_s": {
          "type": "number",
          "minimum": 1
        },
        "device": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "relation_to_ctx": {
          "type": "array",
          "items": {
            "type": "string",
            "minLength": 1,
            "maxLength": 4000
          },
          "maxItems": 100
        },
        "accels": {
          "type": "boolean"
        },
        "decels": {
          "type": "boolean"
        },
        "decel_type": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "baseline_reassessed": {
          "type": "boolean"
        },
        "performed_by": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "assess_baseline": {
          "type": "boolean"
        },
        "decel_recovery": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "tracer_samples": {
          "type": "array",
          "maxItems": 720,
          "items": {
            "type": "object",
            "properties": {
              "offset_ms": {
                "type": "number",
                "minimum": 0
              },
              "bpm": {
                "type": "number",
                "minimum": 0,
                "maximum": 300
              },
              "contraction": {
                "type": "boolean"
              }
            },
            "required": [
              "offset_ms",
              "bpm",
              "contraction"
            ],
            "additionalProperties": false
          }
        }
      },
      "required": [
        "low_bpm",
        "high_bpm",
        "listen_duration_s",
        "device"
      ],
      "additionalProperties": false
    }
  },
  "LABOR.CONTRACTIONS": {
    "subjects": [
      "MOTHER"
    ],
    "schema": {
      "type": "object",
      "properties": {
        "freq_min_low": {
          "type": "number",
          "minimum": 0
        },
        "freq_min_high": {
          "type": "number",
          "minimum": 0
        },
        "duration_s_low": {
          "type": "number",
          "minimum": 0
        },
        "duration_s_high": {
          "type": "number",
          "minimum": 0
        },
        "strength": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "palpated_or_reported": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "performed_by": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        }
      },
      "required": [
        "freq_min_low",
        "duration_s_low"
      ],
      "additionalProperties": false
    }
  },
  "LABOR.PROGRESS": {
    "subjects": [
      "MOTHER"
    ],
    "schema": {
      "type": "object",
      "properties": {
        "dilation_cm": {
          "type": "number",
          "minimum": 0,
          "maximum": 10,
          "multipleOf": 0.5
        },
        "effacement_pct": {
          "type": "number",
          "minimum": 0,
          "maximum": 100
        },
        "cervical_length_cm": {
          "type": "number",
          "minimum": 0
        },
        "station": {
          "type": "integer",
          "minimum": -5,
          "maximum": 5
        },
        "cervix_consistency": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "cervix_position": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "notes": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "active_labor": {
          "type": "boolean"
        },
        "exam_by": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "performed_by": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "qualifier": {
          "type": "string",
          "enum": [
            "lip",
            "rim"
          ]
        }
      },
      "required": [
        "dilation_cm"
      ],
      "additionalProperties": false
    }
  },
  "LABOR.STATUS": {
    "subjects": [
      "MOTHER"
    ],
    "schema": {
      "type": "object",
      "properties": {
        "value": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "performed_by": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        }
      },
      "required": [
        "value"
      ],
      "additionalProperties": false
    }
  },
  "LABOR.COMFORT": {
    "subjects": [
      "MOTHER"
    ],
    "schema": {
      "type": "object",
      "properties": {
        "coping": {
          "type": "boolean"
        },
        "pain_score": {
          "type": "number",
          "minimum": 0,
          "maximum": 10
        },
        "signs_plan": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "performed_by": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        }
      },
      "required": [],
      "additionalProperties": false
    }
  },
  "LABOR.POSITION": {
    "subjects": [
      "MOTHER"
    ],
    "schema": {
      "type": "object",
      "properties": {
        "position": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "in_water": {
          "type": "boolean"
        },
        "performed_by": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        }
      },
      "required": [
        "position"
      ],
      "additionalProperties": false
    }
  },
  "LABOR.FETAL_POSITION": {
    "subjects": [
      "FETUS"
    ],
    "schema": {
      "type": "object",
      "properties": {
        "presentation": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "position": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "attitude": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "asynclitic": {
          "type": "boolean"
        },
        "performed_by": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        }
      },
      "required": [
        "presentation"
      ],
      "additionalProperties": false
    }
  },
  "LABOR.MEMBRANES": {
    "subjects": [
      "MOTHER"
    ],
    "schema": {
      "type": "object",
      "properties": {
        "status": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "fluid_color": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "pooling": {
          "type": "boolean"
        },
        "nitrazine": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "fern": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "odor": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "performed_by": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        }
      },
      "required": [
        "status"
      ],
      "additionalProperties": false
    }
  },
  "MED.ADMIN": {
    "subjects": [
      "MOTHER",
      "NEWBORN"
    ],
    "schema": {
      "type": "object",
      "properties": {
        "drug": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "dose": {
          "type": "number",
          "minimum": 0
        },
        "unit": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "route": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "site": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "lot": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "expiration": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "reasons": {
          "type": "array",
          "items": {
            "type": "string",
            "minLength": 1,
            "maxLength": 4000
          },
          "maxItems": 100
        },
        "status": {
          "type": "string",
          "enum": [
            "Administered",
            "Declined",
            "Held",
            "Deferred"
          ]
        },
        "performed_by": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        }
      },
      "required": [
        "drug",
        "status"
      ],
      "additionalProperties": false
    }
  },
  "MILESTONE": {
    "subjects": [
      "MOTHER",
      "FETUS"
    ],
    "schema": {
      "type": "object",
      "properties": {
        "milestone": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "nuchal_cord": {
          "type": "boolean"
        },
        "nuchal_detail": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "performed_by": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "repeatable": {
          "type": "boolean"
        }
      },
      "required": [
        "milestone"
      ],
      "additionalProperties": false
    }
  },
  "BIRTH": {
    "subjects": [
      "FETUS"
    ],
    "schema": {
      "type": "object",
      "properties": {
        "outcome": {
          "type": "string",
          "enum": [
            "Live birth",
            "Stillbirth"
          ]
        },
        "maternal_position": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "in_water": {
          "type": "boolean"
        },
        "presentation": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "position_of_presenting_part": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "method": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "sex": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "time_estimated": {
          "type": "boolean"
        },
        "shoulder_dystocia": {
          "type": "boolean"
        },
        "maneuvers": {
          "type": "array",
          "items": {
            "type": "string",
            "minLength": 1,
            "maxLength": 4000
          },
          "maxItems": 100
        },
        "head_to_body_interval_s": {
          "type": "number",
          "minimum": 0
        },
        "performed_by": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "caught_by": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        }
      },
      "required": [
        "outcome",
        "method"
      ],
      "additionalProperties": false
    }
  },
  "CORD": {
    "subjects": [
      "NEWBORN"
    ],
    "schema": {
      "type": "object",
      "properties": {
        "clamped_at": {
          "type": "string",
          "format": "date-time"
        },
        "cut_at": {
          "type": "string",
          "format": "date-time"
        },
        "cut_by": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "vessels": {
          "type": "string",
          "enum": [
            "2",
            "3"
          ]
        },
        "cord_blood_collected": {
          "type": "boolean"
        },
        "performed_by": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        }
      },
      "required": [],
      "additionalProperties": false
    }
  },
  "PP.BLOOD_LOSS": {
    "subjects": [
      "MOTHER"
    ],
    "schema": {
      "type": "object",
      "properties": {
        "amount_ml": {
          "type": "number",
          "minimum": 0
        },
        "method": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "descriptor": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "performed_by": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "hypovolemia_signs": {
          "type": "boolean"
        }
      },
      "required": [],
      "additionalProperties": false,
      "anyOf": [
        {
          "required": [
            "amount_ml",
            "method"
          ]
        },
        {
          "required": [
            "descriptor"
          ]
        }
      ]
    }
  },
  "NB.COLOR": {
    "subjects": [
      "NEWBORN"
    ],
    "schema": {
      "type": "object",
      "properties": {
        "value": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "performed_by": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "jaundice": {
          "type": "boolean"
        }
      },
      "required": [
        "value"
      ],
      "additionalProperties": false
    }
  },
  "NB.RESUSCITATION": {
    "subjects": [
      "NEWBORN"
    ],
    "schema": {
      "type": "object",
      "properties": {
        "interventions": {
          "type": "array",
          "items": {
            "type": "string",
            "minLength": 1,
            "maxLength": 4000
          },
          "maxItems": 100
        },
        "started_at": {
          "type": "string",
          "format": "date-time"
        },
        "stopped_at": {
          "type": "string",
          "format": "date-time"
        },
        "notes": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "performed_by": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        }
      },
      "required": [
        "interventions"
      ],
      "additionalProperties": false
    }
  },
  "NOTE.ADMISSION": {
    "subjects": [
      "MOTHER",
      "FETUS",
      "NEWBORN"
    ],
    "schema": {
      "type": "object",
      "properties": {
        "text": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "performed_by": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "communication_log": {
          "type": "array",
          "maxItems": 100,
          "items": {
            "type": "object",
            "properties": {
              "person": {
                "type": "string",
                "minLength": 1,
                "maxLength": 4000
              },
              "role": {
                "type": "string",
                "minLength": 1,
                "maxLength": 4000
              },
              "facility": {
                "type": "string",
                "minLength": 1,
                "maxLength": 4000
              },
              "channel": {
                "type": "string",
                "minLength": 1,
                "maxLength": 4000
              },
              "time": {
                "type": "string",
                "format": "date-time"
              }
            },
            "required": [
              "person"
            ],
            "additionalProperties": false
          }
        },
        "planned_site": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "actual_site": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "site_address": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "parity": {
          "type": "integer",
          "minimum": 0
        },
        "third_stage_management": {
          "type": "string",
          "enum": [
            "ACTIVE",
            "PHYSIOLOGIC"
          ]
        }
      },
      "required": [
        "text"
      ],
      "additionalProperties": false
    }
  },
  "NOTE.DISCHARGE": {
    "subjects": [
      "MOTHER",
      "FETUS",
      "NEWBORN"
    ],
    "schema": {
      "type": "object",
      "properties": {
        "text": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "performed_by": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "communication_log": {
          "type": "array",
          "maxItems": 100,
          "items": {
            "type": "object",
            "properties": {
              "person": {
                "type": "string",
                "minLength": 1,
                "maxLength": 4000
              },
              "role": {
                "type": "string",
                "minLength": 1,
                "maxLength": 4000
              },
              "facility": {
                "type": "string",
                "minLength": 1,
                "maxLength": 4000
              },
              "channel": {
                "type": "string",
                "minLength": 1,
                "maxLength": 4000
              },
              "time": {
                "type": "string",
                "format": "date-time"
              }
            },
            "required": [
              "person"
            ],
            "additionalProperties": false
          }
        }
      },
      "required": [
        "text"
      ],
      "additionalProperties": false
    }
  },
  "NOTE.PROGRESS": {
    "subjects": [
      "MOTHER",
      "FETUS",
      "NEWBORN"
    ],
    "schema": {
      "type": "object",
      "properties": {
        "text": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "performed_by": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "communication_log": {
          "type": "array",
          "maxItems": 100,
          "items": {
            "type": "object",
            "properties": {
              "person": {
                "type": "string",
                "minLength": 1,
                "maxLength": 4000
              },
              "role": {
                "type": "string",
                "minLength": 1,
                "maxLength": 4000
              },
              "facility": {
                "type": "string",
                "minLength": 1,
                "maxLength": 4000
              },
              "channel": {
                "type": "string",
                "minLength": 1,
                "maxLength": 4000
              },
              "time": {
                "type": "string",
                "format": "date-time"
              }
            },
            "required": [
              "person"
            ],
            "additionalProperties": false
          }
        }
      },
      "required": [
        "text"
      ],
      "additionalProperties": false
    }
  },
  "CARE.TASK": {
    "subjects": [
      "MOTHER",
      "NEWBORN"
    ],
    "schema": {
      "type": "object",
      "properties": {
        "task_id": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "status": {
          "type": "string",
          "enum": [
            "COMPLETE",
            "DEFERRED",
            "NOT_APPLICABLE"
          ]
        },
        "note": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "source_event_id": {
          "type": "string",
          "format": "uuid"
        }
      },
      "required": [
        "task_id",
        "status",
        "note",
        "source_event_id"
      ],
      "additionalProperties": false
    }
  },
  "NB.SCREEN": {
    "subjects": [
      "NEWBORN"
    ],
    "schema": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "result": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "values": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "name": {
                "type": "string",
                "minLength": 1,
                "maxLength": 4000
              },
              "value": {
                "type": "number"
              },
              "unit": {
                "type": "string",
                "minLength": 1,
                "maxLength": 4000
              }
            },
            "required": [
              "name",
              "value"
            ],
            "additionalProperties": false
          },
          "maxItems": 100
        },
        "right_hand_pct": {
          "type": "number",
          "minimum": 0,
          "maximum": 100
        },
        "foot_pct": {
          "type": "number",
          "minimum": 0,
          "maximum": 100
        },
        "room_air": {
          "type": "boolean"
        },
        "early_discharge": {
          "type": "boolean"
        },
        "attempt_number": {
          "type": "integer",
          "minimum": 1,
          "maximum": 10
        }
      },
      "required": [
        "type",
        "result"
      ],
      "additionalProperties": false
    }
  },
  "TRANSPORT": {
    "subjects": [
      "MOTHER",
      "NEWBORN"
    ],
    "schema": {
      "type": "object",
      "properties": {
        "transport_type": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "decision_at": {
          "type": "string",
          "format": "date-time"
        },
        "deciding_provider_id": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "urgency": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "reasons": {
          "type": "array",
          "items": {
            "type": "string",
            "minLength": 1,
            "maxLength": 4000
          },
          "maxItems": 100
        },
        "reason_other": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "mode": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "transporting_from": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "receiving_facility": {
          "type": "object",
          "properties": {
            "name": {
              "type": "string",
              "minLength": 1,
              "maxLength": 4000
            },
            "phone": {
              "type": "string",
              "minLength": 1,
              "maxLength": 4000
            },
            "contact_name": {
              "type": "string",
              "minLength": 1,
              "maxLength": 4000
            }
          },
          "required": [
            "name"
          ],
          "additionalProperties": false
        },
        "facility_notified_at": {
          "type": "string",
          "format": "date-time"
        },
        "condition_at_transport": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "arrived_facility_at": {
          "type": "string",
          "format": "date-time"
        },
        "disposition_of_mother": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "accompanying": {
          "type": "array",
          "items": {
            "type": "string",
            "minLength": 1,
            "maxLength": 4000
          },
          "maxItems": 100
        },
        "outcome_followup": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        }
      },
      "required": [
        "transport_type",
        "decision_at",
        "reasons"
      ],
      "additionalProperties": false
    }
  }
} as const;
export interface EventPayloadsV2 {
  "VITALS.BP": { "systolic": number; "diastolic": number; "position"?: string; "cuff_size"?: string; "arm"?: string; "performed_by"?: string };
  "VITALS.PULSE": { "rate": number; "rhythm"?: string; "performed_by"?: string };
  "VITALS.TEMP": { "value_c": number; "method": string; "performed_by"?: string };
  "VITALS.RR": { "rate": number; "quality"?: string; "performed_by"?: string; "respiratory_distress"?: boolean };
  "VITALS.SPO2": { "value_pct": number; "site"?: string; "on_o2"?: boolean; "performed_by"?: string };
  "VITALS.WEIGHT": { "grams": number; "performed_by"?: string };
  "VITALS.HEIGHT": { "cm": number; "performed_by"?: string };
  "LABOR.FHR": { "low_bpm": number; "high_bpm": number; "baseline_bpm"?: number; "listen_duration_s": number; "device": string; "relation_to_ctx"?: (string)[]; "accels"?: boolean; "decels"?: boolean; "decel_type"?: string; "baseline_reassessed"?: boolean; "performed_by"?: string; "assess_baseline"?: boolean; "decel_recovery"?: string; "tracer_samples"?: ({ "offset_ms": number; "bpm": number; "contraction": boolean })[] };
  "LABOR.CONTRACTIONS": { "freq_min_low": number; "freq_min_high"?: number; "duration_s_low": number; "duration_s_high"?: number; "strength"?: string; "palpated_or_reported"?: string; "performed_by"?: string };
  "LABOR.PROGRESS": { "dilation_cm": number; "effacement_pct"?: number; "cervical_length_cm"?: number; "station"?: number; "cervix_consistency"?: string; "cervix_position"?: string; "notes"?: string; "active_labor"?: boolean; "exam_by"?: string; "performed_by"?: string; "qualifier"?: "lip" | "rim" };
  "LABOR.STATUS": { "value": string; "performed_by"?: string };
  "LABOR.COMFORT": { "coping"?: boolean; "pain_score"?: number; "signs_plan"?: string; "performed_by"?: string };
  "LABOR.POSITION": { "position": string; "in_water"?: boolean; "performed_by"?: string };
  "LABOR.FETAL_POSITION": { "presentation": string; "position"?: string; "attitude"?: string; "asynclitic"?: boolean; "performed_by"?: string };
  "LABOR.MEMBRANES": { "status": string; "fluid_color"?: string; "pooling"?: boolean; "nitrazine"?: string; "fern"?: string; "odor"?: string; "performed_by"?: string };
  "MED.ADMIN": { "drug": string; "dose"?: number; "unit"?: string; "route"?: string; "site"?: string; "lot"?: string; "expiration"?: string; "reasons"?: (string)[]; "status": "Administered" | "Declined" | "Held" | "Deferred"; "performed_by"?: string };
  "MILESTONE": { "milestone": string; "nuchal_cord"?: boolean; "nuchal_detail"?: string; "performed_by"?: string; "repeatable"?: boolean };
  "BIRTH": { "outcome": "Live birth" | "Stillbirth"; "maternal_position"?: string; "in_water"?: boolean; "presentation"?: string; "position_of_presenting_part"?: string; "method": string; "sex"?: string; "time_estimated"?: boolean; "shoulder_dystocia"?: boolean; "maneuvers"?: (string)[]; "head_to_body_interval_s"?: number; "performed_by"?: string; "caught_by"?: string };
  "CORD": { "clamped_at"?: string; "cut_at"?: string; "cut_by"?: string; "vessels"?: "2" | "3"; "cord_blood_collected"?: boolean; "performed_by"?: string };
  "PP.BLOOD_LOSS": { "amount_ml"?: number; "method"?: string; "descriptor"?: string; "performed_by"?: string; "hypovolemia_signs"?: boolean };
  "NB.COLOR": { "value": string; "performed_by"?: string; "jaundice"?: boolean };
  "NB.RESUSCITATION": { "interventions": (string)[]; "started_at"?: string; "stopped_at"?: string; "notes"?: string; "performed_by"?: string };
  "NOTE.ADMISSION": { "text": string; "performed_by"?: string; "communication_log"?: ({ "person": string; "role"?: string; "facility"?: string; "channel"?: string; "time"?: string })[]; "planned_site"?: string; "actual_site"?: string; "site_address"?: string; "parity"?: number; "third_stage_management"?: "ACTIVE" | "PHYSIOLOGIC" };
  "NOTE.DISCHARGE": { "text": string; "performed_by"?: string; "communication_log"?: ({ "person": string; "role"?: string; "facility"?: string; "channel"?: string; "time"?: string })[] };
  "NOTE.PROGRESS": { "text": string; "performed_by"?: string; "communication_log"?: ({ "person": string; "role"?: string; "facility"?: string; "channel"?: string; "time"?: string })[] };
  "CARE.TASK": { "task_id": string; "status": "COMPLETE" | "DEFERRED" | "NOT_APPLICABLE"; "note": string; "source_event_id": string };
  "NB.SCREEN": { "type": string; "result": string; "values"?: ({ "name": string; "value": number; "unit"?: string })[]; "right_hand_pct"?: number; "foot_pct"?: number; "room_air"?: boolean; "early_discharge"?: boolean; "attempt_number"?: number };
  "TRANSPORT": { "transport_type": string; "decision_at": string; "deciding_provider_id"?: string; "urgency"?: string; "reasons": (string)[]; "reason_other"?: string; "mode"?: string; "transporting_from"?: string; "receiving_facility"?: { "name": string; "phone"?: string; "contact_name"?: string }; "facility_notified_at"?: string; "condition_at_transport"?: string; "arrived_facility_at"?: string; "disposition_of_mother"?: string; "accompanying"?: (string)[]; "outcome_followup"?: string };
}
export const eventCatalogV3 = {
  "TRANSPORT": {
    "subjects": [
      "MOTHER",
      "NEWBORN"
    ],
    "schema": {
      "type": "object",
      "properties": {
        "transport_type": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "decision_at": {
          "type": "string",
          "format": "date-time"
        },
        "deciding_provider_id": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "urgency": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "reasons": {
          "type": "array",
          "items": {
            "type": "string",
            "minLength": 1,
            "maxLength": 4000
          },
          "maxItems": 100
        },
        "reason_other": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "mode": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "transporting_from": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "receiving_facility": {
          "type": "object",
          "properties": {
            "name": {
              "type": "string",
              "minLength": 1,
              "maxLength": 4000
            },
            "phone": {
              "type": "string",
              "minLength": 1,
              "maxLength": 4000
            },
            "contact_name": {
              "type": "string",
              "minLength": 1,
              "maxLength": 4000
            },
            "contact_role": {
              "type": "string",
              "minLength": 1,
              "maxLength": 4000
            }
          },
          "required": [
            "name"
          ],
          "additionalProperties": false
        },
        "facility_notified_at": {
          "type": "string",
          "format": "date-time"
        },
        "condition_at_transport": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "arrived_facility_at": {
          "type": "string",
          "format": "date-time"
        },
        "disposition_of_mother": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "accompanying": {
          "type": "array",
          "items": {
            "type": "string",
            "minLength": 1,
            "maxLength": 4000
          },
          "maxItems": 100
        },
        "outcome_followup": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "ems": {
          "type": "object",
          "properties": {
            "called": {
              "type": "boolean"
            },
            "called_at": {
              "type": "string",
              "format": "date-time"
            },
            "arrived_at": {
              "type": "string",
              "format": "date-time"
            },
            "departed_at": {
              "type": "string",
              "format": "date-time"
            }
          },
          "required": [
            "called"
          ],
          "additionalProperties": false
        },
        "contact_phone": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4000
        },
        "handoff_sbar": {
          "type": "object",
          "properties": {
            "situation": {
              "type": "string",
              "minLength": 1,
              "maxLength": 4000
            },
            "background": {
              "type": "string",
              "minLength": 1,
              "maxLength": 4000
            },
            "assessment": {
              "type": "string",
              "minLength": 1,
              "maxLength": 4000
            },
            "recommendation": {
              "type": "string",
              "minLength": 1,
              "maxLength": 4000
            }
          },
          "required": [],
          "additionalProperties": false
        }
      },
      "required": [
        "transport_type",
        "decision_at",
        "reasons"
      ],
      "additionalProperties": false
    }
  }
} as const;
export const latestEventCatalog = { ...eventCatalog, ...eventCatalogV2, ...eventCatalogV3 } as const;
export const latestSchemaVersions = {"VITALS.BP": 2, "VITALS.PULSE": 2, "VITALS.TEMP": 2, "VITALS.RR": 2, "VITALS.SPO2": 2, "VITALS.WEIGHT": 2, "VITALS.HEIGHT": 2, "PRENATAL.FUNDAL_HEIGHT": 1, "PRENATAL.FHT": 1, "PRENATAL.FETAL_PRESENTATION": 1, "PRENATAL.FETAL_MOVEMENT": 1, "PRENATAL.EDEMA": 1, "LAB.URINE_DIP": 1, "EXAM.SECTION": 1, "LABOR.FHR": 2, "LABOR.CONTRACTIONS": 2, "LABOR.PROGRESS": 2, "LABOR.STATUS": 2, "LABOR.COMFORT": 2, "LABOR.POSITION": 2, "LABOR.FETAL_POSITION": 2, "LABOR.MEMBRANES": 2, "IO.INTAKE": 1, "IO.OUTPUT": 1, "MED.ADMIN": 2, "THERAPY": 1, "MILESTONE": 2, "ROM": 1, "BIRTH": 2, "APGAR": 1, "CORD": 2, "PLACENTA": 1, "PP.FUNDUS": 1, "PP.BLOOD_LOSS": 2, "PP.PERINEUM": 1, "NB.COLOR": 2, "NB.FEEDING": 1, "NB.LOCATION": 1, "NB.RESUSCITATION": 2, "NB.MEASUREMENTS": 1, "NB.EXAM": 1, "NB.SCREEN": 2, "TRANSPORT": 3, "NOTE.ADMISSION": 2, "NOTE.DISCHARGE": 2, "NOTE.PROGRESS": 2, "ATTENDANT.ARRIVAL": 1, "ATTENDANT.DEPARTURE": 1, "SCREEN.EPDS": 1, "CONSENT.DECISION": 1, "CHECKLIST.ITEM": 1, "PRENATAL.CONTEXT": 1, "PRENATAL.CARE_STATUS": 1, "PRENATAL.DATING": 1, "PRENATAL.VISIT_DETAILS": 1, "NB.BLOOD_TYPE": 1, "POSTPARTUM.OUTCOME_REVIEW": 1, "CARE.TASK": 2, "PP.STATUS": 1, "BIRTH.DISCHARGE": 1, "NB.BALLARD": 1, "PP.EPDS": 1, "PP.COURSE_ASSESSMENT": 1, "NB.COURSE_ASSESSMENT": 1, "US.MEASUREMENT": 1} as const;
export interface EventPayloadsV3 {
  "TRANSPORT": { "transport_type": string; "decision_at": string; "deciding_provider_id"?: string; "urgency"?: string; "reasons": (string)[]; "reason_other"?: string; "mode"?: string; "transporting_from"?: string; "receiving_facility"?: { "name": string; "phone"?: string; "contact_name"?: string; "contact_role"?: string }; "facility_notified_at"?: string; "condition_at_transport"?: string; "arrived_facility_at"?: string; "disposition_of_mother"?: string; "accompanying"?: (string)[]; "outcome_followup"?: string; "ems"?: { "called": boolean; "called_at"?: string; "arrived_at"?: string; "departed_at"?: string }; "contact_phone"?: string; "handoff_sbar"?: { "situation"?: string; "background"?: string; "assessment"?: string; "recommendation"?: string } };
}
